import Confirmation from "./Confirmation/routes.js";
import Contact from "./Contact/routes.js";
import Files from "./Files/routes.js";
import FlightHours from "./FlightHours/routes.js";
import Licences from "./Licences/routes.js";
import Training from "./Training/routes.js";

export default [
    ...Contact,
    ...Licences,
    ...Training,
    ...Files,
    ...FlightHours,
    ...Confirmation
];
